<template>
    <div>
        <app-nav></app-nav>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-6">
                    <h3> Fiche de {{interimaireById.prenom}} {{interimaireById.nom}}</h3>
                </div>
            </div>         
            <div class="row">
                <div class="col-xs-1 col-sm-1">
                </div>
                <div class="col-xs-12 col-sm-8">
                   
                    <p  class="text-left">
                        <b> Nom: {{ interimaireById.nom}} </b>
                    </p>
                    <p  class="text-left">
                        <b> Prenom: {{ interimaireById.prenom}}</b>
                    </p>
                    <p  class="text-left">
                        <b> Salutation: {{ interimaireById.salutation}}</b>
                    </p>      
                    <p  class="text-left">
                        <b> Num. ss: {{ interimaireById.numss}}</b>
                    </p>      
                    <p  class="text-left">
                        <b> Adresse: {{ interimaireById.adresse}} </b>
                    </p>
                    <p  class="text-left">
                        <b> Téléphone: {{ interimaireById.telephone}} </b>
                    </p>
                    <p  class="text-left">
                        <b> Email: {{ interimaireById.email}} </b>
                    </p>
                     <p  class="text-left">
                        <b> Date de naissance: {{ moment(interimaireById.dateNaiss).isValid()? moment(interimaireById.dateNaiss).format("DD/MM/YYYY"):""}} </b>
                    </p>
                     <p  class="text-left">
                        <b> Lieu de naissance: {{ interimaireById.lieuNaiss }} </b>
                    </p>
                     <p  class="text-left">
                        <b>Dépt. de naissance: {{ interimaireById.departementNaiss }} </b>
                    </p>
                     <p  class="text-left">
                        <b>Nationalité: {{ interimaireById.nationalite }} </b>
                    </p>
                     <p  class="text-left">
                        <b> Actif: {{ interimaireById.actif }} </b>
                    </p>
                        <router-link to="/interimaires" class="">Retour vers la liste</router-link>
                        <br>
                        <router-link :to="{name: 'InterimaireEdit' , params: { id: interimaireById.id }}"> Editer.</router-link>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import AppNav from '../AppNav'
import { 
    INTERIMAIRE_BY_ID 
    } from '../../constants/interim'
import moment from 'moment'
moment.locale('fr')
export default {
  name: 'interim',
  components: {
    AppNav
  },
  data () {
    return {
      moment: moment,
      interimaireById: {}
    }
  },
  apollo: {
      interimaireById: {
      query: INTERIMAIRE_BY_ID,
      variables() {
        var id = parseInt(this.$route.params.id, 10)
          return{
            id
        }
      }
    }
  }
}
</script>
<style scoped>
body {
  padding-top: 3.5rem;  
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}
</style>




// WEBPACK FOOTER //
// interim.vue?25c90e63